type Char = string; // Represents any single character
// Case 1: Length 9 (e.g., 9,99E+10) - No Mantissa sign, 2-digit Exponent // Case 2: Length 10 (e.g., -9,99E+10) - Mantissa sign, 2-digit Exponent
type CO2EmissionValue = `${Char},${Char}${Char}E${ExponentTwoDigits}` | `${MantissaSign}${Char},${Char}${Char}E${ExponentTwoDigits}`;
// Exponent MUST now be exactly two digits (DD)
type ExponentTwoDigits = `${MantissaSign}${Char}${Char}`; // e.g., +10 or -05

interface ICO2Emission {
	readonly value: CO2EmissionValue;
}

type MantissaSign = '-' | '+';

export default class CO2Emission implements ICO2Emission {
	public get value(): CO2EmissionValue {
		return this.#value;
	}

	#value: CO2EmissionValue;
	public constructor({ value }: ICO2Emission) {
		assertIsValidCO2(value);
		this.#value = value;
	}
}

// The regex enforces:
// 1. Mantissa: [+-]?[0-9] followed by a comma, then two digits (e.g., -9,99 to +9,99)
// 2. Separator: Literal 'E'
// 3. Exponent: [+-] followed by2 digits (e.g., -99 to +99)
const validCO2EmissionRegex: RegExp = /^[+-]?\d,\d{2}E[+-]\d{2}$/;

function assertIsValidCO2(value: unknown): asserts value is string {
	if (typeof value === 'string' && validCO2EmissionRegex.test(value)) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be a valid CO2 Emission value, syntax: 0,00E+00`);
}
